// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,


  //** Test */

  //  apiBaseUrl: 'https://localhost:5001/api/',
  //  apiPreBaseUrl: 'https://localhost:5001/',
  // apiBaseUrl: 'https://cosmiccoreapi-service-343894636942.us-central1.run.app/api/',
  //  apiPreBaseUrl: 'https://cosmiccoreapi-service-343894636942.us-central1.run.app/',
  //  urlPostPDF: 'https://cosmiccoreapi-service-343894636942.us-central1.run.app/api/Scan/UploadDocumentQbo/',
  //  qboConnectUrl: 'http://localhost:55742/Default?token=',
  //  stripePaymentUrl: 'http://localhost:51152/PayInvoice?token=',
  //  paymentapp: 'http://localhost:4206/#/',
  //  paymentreturnURL: "http://localhost:4200/#/myaccount",


  //** Live  */

  apiBaseUrl: 'https://cosmiccoreapi-service-343894636942.australia-southeast1.run.app/api/',
  apiPreBaseUrl: 'https://cosmiccoreapi-service-343894636942.australia-southeast1.run.app/',
  urlPostPDF: 'https://cosmiccoreapi-service-343894636942.australia-southeast1.run.app/api/Scan/UploadDocumentQbo/',
  qboConnectUrl: 'https://reckonauthorize-net8-343894636942.australia-southeast1.run.app/Default?token=',
  paymentapp: 'https://paymenthub.cosmicbills.com/#/',
  paymentreturnURL: "https://rah.cosmicbills.com/#/myaccount",
  stripePaymentUrl: 'https://cosmicinv.com/CosmicBillsRahPay/PayInvoice?token='


};

